import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, HostListener, OnInit, Output, SimpleChanges } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { IAddon } from 'src/app/Interfaces/Models/Addon.interface';
import { AddonService } from 'src/app/services/addon/addon.service';
import { ShopcartService } from 'src/app/services/shopcart/shopcart.service';
import { TransportationService } from 'src/app/services/transportation/transportation.service';
import { CurrencyService } from 'src/app/services/currency/currency.service';
import { ICurrency } from 'src/app/models/Currency.model';
import { IShopcart } from 'src/app/models/Shopcart.model';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DiscountService } from 'src/app/services/discount/discount.service';
import { BookingService } from 'src/app/services/booking/booking.service';
import { ToastService } from 'src/app/services/toast/toast.service';
import { StepEnum } from 'src/app/models/enums/Step.enum';
import { RouterService } from 'src/app/services/router/router.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ITransportation } from 'src/app/models/Transportation.model';
import { IProductShopcart } from "src/app/models/ProductShopcart.model";
import { environment } from 'src/environment/environment';
import { PRODUCT_IS_NOT_IN_THE_COUPON_ERROR } from 'src/app/models/errors/coupon.error';
import { ProductTypeEnum } from 'src/app/models/enums/ProductType.enum';
import { IDiscountWeek } from 'src/app/models/Discount.model';
import { TranslateService } from '@ngx-translate/core';
import { ServiceService } from 'src/app/services/service/service.service';

@Component({
  selector: 'app-shopcar-resume',
  templateUrl: './shopcar-resume.component.html',
  styleUrls: ['./shopcar-resume.component.css'],
})
export class ShopcarResumeComponent implements OnInit, AfterViewInit {
  @Output() onPaymentSection = new EventEmitter<boolean>();

  public transportationIdADO: number = environment.ADDONS.ADO;

  public showCollapse: boolean;
  public showCollapseDiscount: boolean;
  public showDiscountError: boolean = false;

  public showDiscountErrorDaysInAdvance: boolean = false;
  public daysInAdvance: number = 0;

  public showDiscountErrorNotApplicable: boolean = false;

  public showDiscountErrorDayOnTheWeek: boolean = false;
  public weekInventory: IDiscountWeek = {
    monday: true,
    tuesday: true,
    wednesday: true,
    thursday: true,
    friday: true,
    saturday: true,
    sunday: true,
  };

  public showDiscount: boolean = false;

  public bookingFull: boolean = false;

  public stepEnum = StepEnum;

  public total$!: Observable<number>;
  public currency$!: Observable<ICurrency>;
  public shopcart$: Observable<IShopcart> = new Observable();
  public step$: Observable<StepEnum> = new Observable();
  public stepBlock$: Observable<boolean> = new Observable();
  public bogo: number = 0;

  public discountForm: FormGroup = new FormGroup({
    discount: new FormControl('', [Validators.required]),
  });

  public discountFormValid: boolean = false;
  public shopCarCoupon: string = '';
  public showLoader: boolean = false;
  private clickSubject = new Subject<void>();
  public dynamicPrice: boolean = false;

  constructor(
    private translateService: TranslateService,
    private currencyService: CurrencyService,
    private shopcartService: ShopcartService,
    private addonService: AddonService,
    private discountService: DiscountService,
    private transportationService: TransportationService,
    private bookingService: BookingService,
    private toastService: ToastService,
    private routerService: RouterService,
    private serviceService: ServiceService,
    public router: Router,
    public activatedRoute: ActivatedRoute,
    private detectChanges: ChangeDetectorRef
  ) {
    this.activatedRoute.url.subscribe((url) => {
      // Check the route or any condition you need
      this.showDiscount = !url.some((segment) =>
        segment.path.includes('payment')
      );
    });

    this.showCollapse = false;
    this.showCollapseDiscount = false;
    this.clickSubject.pipe(
      debounceTime(300)  // Ajusta el tiempo de espera entre clics
    ).subscribe(() => {
      let payment = this.routerService.goToNext();

      if (payment) {
        this.onPaymentSection.emit(true);
      }
    });
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.checkScreenSize();
  }

  ngOnInit(): void {
    this.total$ = this.shopcartService.total$;
    this.currency$ = this.currencyService.currency$;
    this.shopcart$ = this.shopcartService.shopcart$;
    this.step$ = this.routerService.stepBooking$;
    this.stepBlock$ = this.routerService.stepBlock$;
    this.dynamicPrice = this.serviceService.getEnableDynamicPrice();

    this.checkScreenSize();
  }

  ngAfterViewInit() {
    // console.info('ShopcarResumeComponent');
    let { principalProductType, principalLocationId, principalLocationName } =
      this.bookingService.getBooking();
    this.routerService.locationId = principalLocationId;
    this.routerService.locationName = principalLocationName;
    this.showDiscount =
      principalProductType == ProductTypeEnum.COMBO
        ? false
        : this.discountService.getCurrentDiscount() == null;
    this.detectChanges.detectChanges();
    this.discountForm.statusChanges.subscribe((data) => {
      if (data == 'VALID') {
        this.discountFormValid = true;
      }

      if (data == 'INVALID') {
        this.discountFormValid = false;
      }
    });

    this.bookingService.booking$.subscribe((booking) => {
      if (
        booking.bookingService &&
        booking.bookingCalendar &&
        booking.bookingPax &&
        booking.bookingSchedule
      ) {
        this.bookingFull = true;
      } else {
        this.bookingFull = false;
      }
    });
    
    this.shopcartService.couponQADynamic$
    .pipe(distinctUntilChanged())
    .subscribe(async (coupon) => {
      //coupon = ''+coupon?.toUpperCase();
      if(this.discountForm.value.discount != coupon)
      this.discountForm.value.discount = coupon;
      //console.log('form',this.discountForm.value.discount);
      let shop = this.shopcartService.getShopcart();

      if(this.discountForm.value.discount !== null 
        && this.discountForm.value.discount !== undefined 
        && coupon !== null
        && shop.discountCode !== coupon?.toUpperCase())
      {
        //console.log('this.discountForm.value.discount',this.discountForm.value.discount);
        //console.log('valor de shop.discountCode',shop.discountCode);
        //console.log('valor de coupon',coupon);
        this.loadCalender();
        this.onApplyDiscount();
      }
    });
    //console.log('Shopcar dynamic discount',this.shopcartService.getDynamicDiscount());
  }

  public async loadCalender()
  {
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);

    let responseDiscount = await this.discountService.getDiscount(
      this.discountForm.value.discount,
      tomorrow
          );
    //this.shopcartService.setDiscount(responseDiscount);
    this.bookingService.loadDiscount(responseDiscount);
  }

  onClickCollapse() {
    this.showCollapse = !this.showCollapse;
  }

  onDeleteAddon(addon: IAddon) {
    this.addonService.removeAddon(addon);
  }

  //#region Transportation
  onDeleteTransportation(transportation: ITransportation | null) {
    this.transportationService.removeTransportation(transportation);
  }
  //#endregion

  //#region Section Card Discount
  async onApplyDiscount(event?: any): Promise<void> {
    // console.log('onApplyDiscount');
    this.showLoader = true;

    let discountCode = this.discountForm.value.discount;

    try {
      this.showDiscountError = false;
      this.showDiscountErrorDaysInAdvance = false;
      this.showDiscountErrorNotApplicable = false;
      this.showDiscountErrorDayOnTheWeek = false;

      let shopcartCurrent = this.shopcartService.getShopcart();
      let checkInDate = shopcartCurrent.checkInDate;

      //For Selva Mágica
      if (shopcartCurrent.productList.find((i) => i.locationId == 10)) {
        await this.bookingService.loadProduct(discountCode);
      }

      if (!checkInDate) {
        throw false;
      }

      let responseDiscount = await this.discountService.getDiscount(
        discountCode,
        checkInDate
      );

      if (!this.isValidateDay(responseDiscount.week, checkInDate?.getDay())) {
        this.weekInventory = responseDiscount.week;
        this.showDiscountErrorDayOnTheWeek = true;
        this.showLoader = false;
        return; //throw false;
      }

      let differenceInDays = this.differenceInDays(new Date(), checkInDate);

      if (
        responseDiscount.daysInAdvance != null &&
        responseDiscount.daysInAdvance > 0 &&
        differenceInDays < responseDiscount.daysInAdvance
      ) {
        //this.toastService.showToast(`${responseDiscount.code}`);
        this.daysInAdvance = responseDiscount.daysInAdvance;
        this.showDiscountErrorDaysInAdvance = true;
        this.showLoader = false;
        return; //throw false;
      }

      if (
        responseDiscount.productList.filter((discountByProduct) =>
          shopcartCurrent.productList
            .map((shopcartByProduct) => shopcartByProduct.id)
            .includes(discountByProduct.id)
        ).length == 0
      ) {
        this.showDiscountErrorNotApplicable = true;
        this.showLoader = false;
        return; //throw false; //new COUPON_NOT_APPLICABLE_ERROR(this.translateService);
      }


      this.shopcartService.setDynamicDiscountCoupon(this.shopcartService.getDynamicDiscount());
      this.shopcartService.setDynamicDiscountStringCoupon(this.shopcartService.getDynamicDiscountString());

      //console.log('temp descuento aplicar',this.shopcartService.getDynamicDiscountCoupon());
      //console.log('temp descuento string aplicar',this.shopcartService.getDynamicDiscountStringCoupon());

      this.shopcartService.setDynamicDiscount(0);
      this.shopcartService.setDynamicDiscountString('');

      this.bogo = responseDiscount.BOGOA;
      this.shopcartService.setDiscount(responseDiscount);
      this.bookingService.loadDiscount(responseDiscount);
      this.showCollapseDiscount = false;

      if (!this.bookingFull) {
        this.routerService.setBlock(false);
      }

      this.showDiscount = false;

      this.toastService.showToast(`${responseDiscount.code}`);
      this.showLoader = false;
    } catch (error) {
      if (error instanceof PRODUCT_IS_NOT_IN_THE_COUPON_ERROR) {
      } else {
        this.showDiscount = true;
        this.showDiscountError = true;
        this.routerService.setBlock(true);
        this.showLoader = false;
      }

      // if (error instanceof COUPON_NOT_APPLICABLE_ERROR) {
      //   this.toastService.showToast(`${error.message}`, 'info');
      // }
    }
  }

  public showDiscountInput() {
    this.showCollapseDiscount = true;
  }

  public cleanSpecialCharacters(event: any) {
    var k;
    k = event.charCode; //         k = event.keyCode;  (Both can be used)
    return (
      (k > 64 && k < 91) ||
      (k > 96 && k < 123) ||
      k == 8 ||
      k == 32 ||
      (k >= 48 && k <= 57)
    );
  }

  public clearDiscountForm(event: any) {
    this.showCollapseDiscount = false;
    this.showDiscountError = false;
    this.showDiscountErrorDaysInAdvance = false;
    this.showDiscountErrorNotApplicable = false;

    this.discountForm.reset();
    this.routerService.setBlock(false);
  }

  public renderDiscountWeek(discountWeek: IDiscountWeek): string {
    let htmlContent = '<ul>';
    for (const day in discountWeek) {
      if (discountWeek.hasOwnProperty(day)) {
        const status = discountWeek[day as keyof IDiscountWeek] ? 'Sí' : 'No';
        htmlContent += `<li>${day}: ${status}</li>`;
      }
    }
    htmlContent += '</ul>';
    return htmlContent;
  }

  isDayOfTheWeekDisabled(day: string): string {
    return this.weekInventory[day as keyof IDiscountWeek] == false ? "true" : "false";
  }

  public getDayName(dayNumber: number) {
    const date = new Date();
    date.setDate(date.getDate() - date.getDay() + dayNumber);
    return new Intl.DateTimeFormat(this.translateService.currentLang, { weekday: 'short' }).format(date);
  }

  private isValidateDay(
    weekInventory: IDiscountWeek,
    dayNumberOfTheWeek: number
  ) {
    const orderOfTheWeek = [
      'sunday',
      'monday',
      'tuesday',
      'wednesday',
      'thursday',
      'friday',
      'saturday',
    ];
    const nameOfTheWeek: string = orderOfTheWeek[dayNumberOfTheWeek];
    return weekInventory[nameOfTheWeek as keyof IDiscountWeek];
  }
  //#endregion

  private differenceInDays(dateStart: Date, dateEnd: Date) {
    let differenceInTime = dateEnd.getTime() - dateStart.getTime();
    return Math.round(differenceInTime / (1000 * 3600 * 24));
  }

  private checkScreenSize() {
    this.showCollapse = window.innerWidth > 768; // Adjust the threshold based on your design
  }

  public async clearDiscount() {
    let shopcartCurrent = this.shopcartService.getShopcart();
    this.showLoader = true;
    if(this.shopcartService.getCoupon()!=null)
    {
      this.discountForm.value.discount = null;
      this.shopcartService.setCoupon(null);
    }
    this.shopcartService.setDynamicDiscount(this.shopcartService.getDynamicDiscountCoupon());
    this.shopcartService.setDynamicDiscountString(this.shopcartService.getDynamicDiscountStringCoupon());

    //console.log('temp descuento clean',this.shopcartService.getDynamicDiscountCoupon());
    //console.log('temp descuento string clean',this.shopcartService.getDynamicDiscountStringCoupon());

    this.shopcartService.setDynamicDiscountCoupon(0);
    this.shopcartService.setDynamicDiscountStringCoupon('');

    //For Selva Mágica
    if (shopcartCurrent.productList.find((i) => i.locationId == 10)) {
      await this.bookingService.loadProduct(null);
    }

    this.bogo = 0;
    this.discountForm.reset();
    this.shopcartService.removeDiscount();
    this.bookingService.unloadDiscount();

    this.showDiscount = true;

    if (this.showDiscountError) {
      this.showDiscountError = false;
      this.showDiscountErrorDaysInAdvance = false;
      this.showDiscountErrorNotApplicable = false;
      this.routerService.setBlock(false);
    }
    this.showLoader = false;
  }

  public nextPage() {
    /*let payment = this.routerService.goToNext();

    if (payment) {
      this.onPaymentSection.emit(true);
    }*/
   this.clickSubject.next();
  }

  public onBlurDiscount(event: any) {
    if (!event.relatedTarget?.classList.contains('card-discount--button')) {
      this.showCollapseDiscount = false;
    }
  }

  public showPromocodeByProduct(product: IProductShopcart) {
    let { discountCode, comboId, productList } =
      this.shopcartService.getShopcart();

    if (comboId || product.discount > 0) {
      return discountCode && product.id == productList[0].id;
    } else {
      return false;
    }
  }
}
